import getStore from "../store/store";

/**
 * Returns true if the notification settings have been loaded and notifications are disabled.
 * Returns false if notifications are enabled or if the settings have not yet been loaded (undefined).
 */
export default function areNotificationsDisabled(): boolean {
    return getStore().global?.notificationsEnabled === false;
}
